import {
  Action,
  createSlice,
  Dispatch,
  MiddlewareAPI,
  PayloadAction,
} from "@reduxjs/toolkit";
import {
  IDownloads as StrategyFiles,
  IMemberStackEligibleSubscriptions as EligibalSub,
  IMachine as Machine,
  IDisclaimerDocSigned as DisclaimerDocSigned,
  IConfiguraions as Configuraions,
} from "../interfaces";
import { fetchWrapper } from "../components/Service/ApiClient";
import moment from "moment";
import { setLoading } from "./globalLoaderSlice";
import {
  CurrentUser,
  MachineListEndPoint,
} from "../components/Service/EndPoints";
import { element, number, string } from "prop-types";
const { v4: uuidv4 } = require("uuid");

const initialState: {
  machines: Machine[];
  LIMIT: any;
} = { machines: [], LIMIT: 0 };

export const GetConfigurations =
  (callback: Function) => async (dispatch: Dispatch) => {
    dispatch(setLoading(true));

    fetchWrapper
      .get(MachineListEndPoint + "?func=config")
      .then((data) => {
        var result = data;
        var configuraions: Configuraions = {
          APIUrl: "",
          PurchaseAddonLink: "",
          RegMachineLimit: 0,
          DisclaimerDocLink: "",
        };
        for (let i = 0; i < result.length; i++) {
          var m: Configuraions = {
            APIUrl: result[i].APIUrl,
            PurchaseAddonLink: result[i].PurchaseAddonLink,
            RegMachineLimit: result[i].RegMachineLimit,
            DisclaimerDocLink: result[i].DisclaimerDocLink,
          };
          configuraions = m;
        }
        dispatch(setLoading(false));
        callback(configuraions);
      })
      .finally(() => {})
      .catch((error) => callback([]));
  };

export const GetDisclaimerDoc =
  (callback: Function) => async (dispatch: Dispatch) => {
    dispatch(setLoading(true));

    fetchWrapper
      .get(MachineListEndPoint + "?func=doc")
      .then((data) => {
        var result = data.data;
        var objdoc: DisclaimerDocSigned[] = [];
        for (let i = 0; i < result.length; i++) {
          if (result[i].Email === CurrentUser().auth.email) {
            var m: DisclaimerDocSigned = {
              Email: result[i].Email,
              Date: result[i].Date,
              Agreed: result[i].Agreed,
              Name: result[i].Name,
              func: "doc",
            };
            objdoc.push(m);
          }
        }
        dispatch(setLoading(false));
        callback(objdoc);
      })
      .finally(() => {})
      .catch((error) => callback([]));
  };

export const GetEligibalPlans =
  (callback: Function) => async (dispatch: Dispatch) => {
    dispatch(setLoading(true));

    fetchWrapper
      .get(MachineListEndPoint + "?func=sub")
      .then((data) => {
        var result = data;
        var subsription: EligibalSub[] = [];
        for (let i = 0; i < result.length; i++) {
          var m: EligibalSub = {
            StrategyName: result[i].StrategyName,
            Plans: result[i].Plans,
          };
          subsription.push(m);
        }
        dispatch(setLoading(false));
        callback(subsription);
      })
      .finally(() => {})
      .catch((error) => callback([]));
  };
export const GetDownloads =
  (callback: Function) => async (dispatch: Dispatch) => {
    dispatch(setLoading(true));

    fetchWrapper
      .get(MachineListEndPoint + "?func=files")
      .then((data) => {
        var result = data;
        var strategies: StrategyFiles[] = [];

        for (let i = 0; i < result.length; i++) {
          var m: StrategyFiles = {
            Id: uuidv4(),
            StrategyName: result[i].StrategyName,
            StrategyPackageName: result[i].StrategyPackageName,
            svgImage: result[i].SvgImage,
            isLocked: FindInElegibalSub(result[i].StrategyName),
            unlockLink: getLink(),
          };
          strategies.push(m);
        }

        dispatch(setLoading(false));
        callback(strategies);
      })
      .finally(() => {})
      .catch((error) => callback([]));
  };

function getLink() {
  var config = localStorage.getItem("configuraions");
  var configuraions = JSON.parse(config ? config : "");

  return configuraions.PurchaseAddonLink;
}
function FindInElegibalSub(strategyName: any) {
  var eligibleSubscribers = localStorage.getItem("eligibalsub");
  var planConnections: any[];
  var users: any = CurrentUser();
  planConnections = users.planConnections;

  var plans = JSON.parse(
    eligibleSubscribers != null ? eligibleSubscribers : "[]"
  );
  // const plans = result.filter((data: any) => JSON.parse(data.Plans));
  // const plans = result.map((item: any) => JSON.parse(item.Plans));

  var islocked = true;
  planConnections.forEach((element) => {
    plans.forEach((p: any) => {
      if (
        JSON.parse(p.Plans).includes(element.planId) &&
        strategyName === p.StrategyName &&
        islocked
      ) {
        islocked = false;
      }
    });
  });
  return islocked;
}
export const GetMachineList = () => async (dispatch: Dispatch) => {
  dispatch(setLoading(true));

  fetchWrapper
    .get(MachineListEndPoint + "?func=read")
    .then((data) => {
      dispatch(machinesActions.deleteAllData());
      var user = CurrentUser();
      var result = data.data;
      var activeStrategies = data.strategyData;
      var foramatedStrategyname =[];
      for (let i = 0; i < activeStrategies.length; i++) {
        if (user && user.auth.email === activeStrategies[i].Email) {
          foramatedStrategyname.push(   activeStrategies[i].StrategyName )
        }
      }
      localStorage.setItem("activestrategyies", JSON.stringify(foramatedStrategyname));
      for (let i = 0; i < result.length; i++) {
        if (user && user.auth.email === result[i].Email) {
          var m: Machine = {
            Name: result[i].UserName,
            active: true,
            date: moment(result[i].InsertedDate).format(
              "MM-DD-YYYY, h:mm:ss a"
            ),
            machineId: result[i].MachineId,
            description: result[i].Email,
            id: result[i].ID,
            Email: result[i].Email,
            ApplicationName:   foramatedStrategyname.join(" | "),
            important: false,
            PlanName: result[i].PlanName,
          };
          dispatch(machinesActions.machineListReceived(m));
        }
      }
      dispatch(setLoading(false));
    })
    .finally(() => {})

    .catch((error) => console.error("There was an error!", error));
};

export const SaveNewMachine =
  (action: Machine, callback: Function) => async (dispatch: Dispatch) => {
    dispatch(setLoading(true));
    fetchWrapper
      .post(MachineListEndPoint, {
        method: "POST",
        body: action,
      })
      .then((res) => {
        dispatch(setLoading(false));
        callback(res);
      })
      .catch((err) => console.log(err));
  };
export const SaveDisclaimerDocSigned =
  (action: DisclaimerDocSigned, callback: Function) =>
  async (dispatch: Dispatch) => {
    dispatch(setLoading(true));
    fetchWrapper
      .post(MachineListEndPoint, {
        method: "POST",
        body: action,
      })
      .then((res) => {
        dispatch(setLoading(false));
        callback(res);
      })
      .catch((err) => console.log(err));
  };

export const DeleteMachine =
  (id: string, email: string, callback: Function) =>
  async (dispatch: Dispatch) => {
    dispatch(setLoading(true));

    fetchWrapper
      .get(MachineListEndPoint + "?func=del&id=" + id + "&email=" + email)
      .then((data) => {
        dispatch(setLoading(false));
        callback(data);
      })
      .finally(() => {})
      .catch((error) => console.error("There was an error!", error));
  };
const machinesSlice = createSlice({
  name: "machines",
  initialState: initialState,
  reducers: {
    addNewMachine(state, action: PayloadAction<Machine>) {
      state.machines = [action.payload, ...state.machines];
    },
    removeTask(state, action) {
      const newmachinesList = state.machines.filter(
        (task) => task.id !== action.payload
      );
      state.machines = newmachinesList;
    },
    markAsImportant(state, action: PayloadAction<string>) {
      const newTaskFavorited = state.machines.find(
        (task) => task.id === action.payload
      );
      // newTaskFavorited!.important = !newTaskFavorited!.important;
    },
    editMachine(state, action: PayloadAction<Machine>) {
      const taskId = action.payload.id;

      const newTaskEdited: Machine = state.machines.find(
        (task: Machine) => task.id === taskId
      )!;
      const indexTask = state.machines.indexOf(newTaskEdited);
      state.machines[indexTask] = action.payload;
    },
    toggleMachineActive(state, action: PayloadAction<string>) {
      const taskId = action.payload;

      const currTask = state.machines.find((task) => task.id === taskId)!;

      currTask.active = !currTask.active;
    },
    deleteAllData(state) {
      state.machines = [];
    },
    machineListReceived(state, action: PayloadAction<Machine>) {
      state.machines = [action.payload, ...state.machines];
    },
    machineRegLimit(state, action: any) {
      state.LIMIT = action.payload;
    },
  },
});

export const machinesActions = machinesSlice.actions;

export default machinesSlice.reducer;

export const machinesMiddleware =
  (store: MiddlewareAPI) => (next: Dispatch) => (action: Action) => {
    const nextAction = next(action);
    if (action.type.startsWith("machines/")) {
      const machinesList = store.getState().machines.machines;
      localStorage.setItem("machines", JSON.stringify(machinesList));
    }

    if (machinesActions.deleteAllData.match(action)) {
      localStorage.removeItem("machines");
      localStorage.removeItem("directories");
      localStorage.removeItem("darkmode");
    }

    if (machinesActions.removeTask.match(action)) {
      console.log(JSON.parse(localStorage.getItem("machines")!));
      if (localStorage.getItem("machines")) {
        const localStoragemachines = JSON.parse(
          localStorage.getItem("machines")!
        );
        if (localStoragemachines.length === 0) {
          localStorage.removeItem("machines");
        }
      }
    }

    return nextAction;
  };
